import React, { useState } from "react";
import { useFieldFormContext, ErrorMessage } from "../../common";
import "./election-designation.scss";

export const ElectionDesignation = () => {
    const { registerField } = useFieldFormContext();

    const electionTypes = [
        "Primary",
        "General",
        "Special Primary",
        "Special General",
        "Primary Runoff",
        "General Runoff",
        "Special Primary Runoff",
        "Special General Runoff",
        "Convention",
        "Special",
        "Other",
    ];

    const currentYear = new Date().getFullYear();
    const electionYears = Array.from({ length: 6 }, (_, i) => currentYear + i);


    return (
        <fieldset className="checkout-election-designation">
            <legend>Election Designation</legend>
            <div className="form-group election-type checkout-election-designation__field">
                <label htmlFor="election-type" className="checkout-election-designation__label">
                    Election Type
                </label>
                <select
                    className="checkout-election-designation__select"
                    {...registerField({
                        id: "election-type",
                        name: "electionDesignation.electionType",
                        options: {
                            required: { value: true, message: "Select an election type" }
                        }
                    })}
                >
                    <option value="">Select an election type</option>
                    {electionTypes.map(type => (
                        <option key={type} value={type}>
                            {type}
                        </option>
                    ))}
                </select>
            </div>
            <div className="form-group election-year checkout-election-designation__field">
                <label htmlFor="election-year" className="checkout-election-designation__label">
                    Election Year
                </label>
                <select
                    className="checkout-election-designation__select"
                    {...registerField({
                        id: "election-year",
                        name: "electionDesignation.electionYear",
                        options: {
                            required: { value: true, message: "Select an election year" }
                        }
                    })}
                >
                    <option value="">Select an election year</option>
                    {electionYears.map(year => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>
        </fieldset>
    );
}